<template>
  <div class="mr-3 text-sm" style="position: absolute; right: 0;">
    <div><strong>{{distance}}</strong></div>
    <div><strong>{{elevation}}</strong></div>
    <div><strong>{{grade}}</strong></div>
  </div>
</template>

<script>
export default {
  props: ['distance', 'elevation', 'grade']
}
</script>
